"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import { Component, PropSync, Vue } from "vue-property-decorator";
import _ from "lodash";
import { PaymentController } from "@/service/newProdect";
let PaymentNewOptionsMoreDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.name = "PaymentNewOptionsMoreDialog";
    this.dialog = new UiDialogController();
    this.profileModel = {
      country: null,
      // system:null,
      os: null,
      useragent: null,
      systemUnify: null,
      systemUnifyOs: null,
      systemUnifyUa: null,
      systemWindows: null,
      systemWindowsUa: null,
      systemMac: null,
      systemMacUa: null,
      systemAndroid: null,
      systemAndroidUa: null,
      browser: null,
      payment_auto_resolution: null,
      payment_ratio: null,
      auto_timezone: null,
      is_auto_timezone: null,
      timezone: null,
      language: null
    };
  }
  open() {
    this.profileModel.country = this._options.selected.configCountrie;
    this.profileModel.os = this._options.selected.configOs;
    this.profileModel.useragent = this._options.selected.configUseragent;
    this.profileModel.systemUnify = this._options.selected.configSystemUnify;
    this.profileModel.systemUnifyOs = this._options.selected.configSystemUnifyOs;
    this.profileModel.systemUnifyUa = this._options.selected.configSystemUnifyUa;
    this.profileModel.systemWindows = this._options.selected.configSystemWindows;
    this.profileModel.systemWindowsUa = this._options.selected.configSystemWindowsUa;
    this.profileModel.systemMac = this._options.selected.configSystemMac;
    this.profileModel.systemMacUa = this._options.selected.configSystemMacUa;
    this.profileModel.systemAndroid = this._options.selected.configSystemAndroid;
    this.profileModel.systemAndroidUa = this._options.selected.configSystemAndroidUa;
    this.profileModel.browser = this._options.selected.configBrowser;
    this.profileModel.payment_auto_resolution = this._options.selected.configAutoResolution;
    if (!this.profileModel.payment_auto_resolution) {
      this.profileModel.payment_ratio = this._options.selected.configResolution;
    } else {
      this.profileModel.payment_ratio = "payment_auto_resolution_true";
    }
    this.profileModel.language = this._options.selected.configLanguage;
    this.profileModel.auto_timezone = this._options.selected.configAutoTimezone;
    this.profileModel.is_auto_timezone = this._options.selected.configShowAutoTimezone;
    this.profileModel.timezone = this._options.selected.configTimezone;
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
  }
  changeCountry() {
    this.profileModel.language = _.find(this._options.configDatas.data.languages, {
      "id": this.profileModel.country.default_selection.language_id
    });
    this.profileModel.timezone = _.find(this._options.configDatas.data.timezones, {
      "id": this.profileModel.country.default_selection.timezone_id
    });
  }
  changeUnify() {
    if (this.profileModel.systemUnify) {
      this.profileModel.systemUnifyOs = this.profileModel.systemWindows;
      this.profileModel.systemUnifyUa = this.profileModel.systemWindowsUa;
    } else {
      this.profileModel.systemUnifyOs = null;
      this.profileModel.systemUnifyUa = null;
    }
  }
  getNewUa() {
    const windowsUaList = this.profileModel.useragent[this.profileModel.systemWindows];
    if (windowsUaList.length > 1) {
      let newSystemWindowsUa = "";
      do {
        newSystemWindowsUa = windowsUaList[Math.floor(Math.random() * windowsUaList.length)];
      } while (newSystemWindowsUa === this.profileModel.systemWindowsUa);
      this.profileModel.systemWindowsUa = newSystemWindowsUa;
    }
    const macUaList = this.profileModel.useragent[this.profileModel.systemMac];
    if (macUaList.length > 1) {
      let newSystemMacUa = "";
      do {
        newSystemMacUa = macUaList[Math.floor(Math.random() * macUaList.length)];
      } while (newSystemMacUa === this.profileModel.systemMacUa);
      this.profileModel.systemMacUa = newSystemMacUa;
    }
    const androidUaList = this.profileModel.useragent[this.profileModel.systemAndroid];
    if (androidUaList.length > 1) {
      let newSystemAndroidUa = "";
      do {
        newSystemAndroidUa = androidUaList[Math.floor(Math.random() * androidUaList.length)];
      } while (newSystemAndroidUa === this.profileModel.systemAndroidUa);
      this.profileModel.systemAndroidUa = newSystemAndroidUa;
    }
  }
  changeSystem(type) {
    if (type === "windows") {
      this.profileModel.systemWindowsUa = this.profileModel.useragent[this.profileModel.systemWindows][0];
    }
    if (type === "mac") {
      this.profileModel.systemMacUa = this.profileModel.useragent[this.profileModel.systemMac][0];
    }
    if (type === "android") {
      this.profileModel.systemAndroidUa = this.profileModel.useragent[this.profileModel.systemAndroid][0];
    }
  }
  confirm() {
    this._options.selected.configBrowser = this.profileModel.browser;
    this._options.selected.configSystemUnify = this.profileModel.systemUnify;
    this._options.selected.configSystemUnifyOs = this.profileModel.systemUnifyOs;
    this._options.selected.configSystemUnifyUa = this.profileModel.systemUnifyUa;
    this._options.selected.configSystemWindows = this.profileModel.systemWindows;
    this._options.selected.configSystemWindowsUa = this.profileModel.systemWindowsUa;
    this._options.selected.configSystemMac = this.profileModel.systemMac;
    this._options.selected.configSystemMacUa = this.profileModel.systemMacUa;
    this._options.selected.configSystemAndroid = this.profileModel.systemAndroid;
    this._options.selected.configSystemAndroidUa = this.profileModel.systemAndroidUa;
    this._options.selected.configAutoTimezone = this.profileModel.auto_timezone;
    this._options.selected.configCountrie = this.profileModel.country;
    if (this.profileModel.payment_ratio !== "payment_auto_resolution_true") {
      this._options.selected.configResolution = this.profileModel.payment_ratio;
      this._options.selected.configAutoResolution = false;
    } else {
      this._options.selected.configAutoResolution = true;
    }
    this._options.selected.configLanguage = this.profileModel.language;
    this._options.selected.configTimezone = this.profileModel.timezone;
    this.close();
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewOptionsMoreDialog.prototype, "_options", 2);
PaymentNewOptionsMoreDialog = __decorateClass([
  Component(
    {
      components: {
        UiDialog
      }
    }
  )
], PaymentNewOptionsMoreDialog);
export {
  PaymentNewOptionsMoreDialog as default
};
